export enum DefaultVPodGateWayDisplay {
  x1 = -44,
  y1 = 5,
}
